module.exports = __webpack_public_path__ + "img/stena16.1cd5d550.jpg";